<template>
  <section class="container px-0" id="cmp_imager">
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="13 30 395 250.6"
      style="
        enable-background: new 0 0 1900 1270;
        width: 80%;
        height: 470px;
        max-width: 1000px;
        margin: 0 auto;
        display: block;
        overflow: visible;
      "
      xml:space="preserve"
      class="pdf-item"
      id="svg-image"
      :data-bike-id="getFrame?.bike_id"
      crossorigin="anonymous"
    >
      <g id="Cicloprato_Framekit" v-if="getFrame != null">
        <image
          crossorigin="anonymous"
          id="BikeFramekit"
          :width="getFrame.width"
          :height="getFrame.height"
          :data-name="getFrame['data-name']"
          :href="
            '/configurator/configurations/' +
            bikeConfiguration[0]?.directory +
            '/' +
            getFrame['data-href']
          "
          :transform="getFrame.transform"
        ></image>
      </g>
      <g
        :data-idcat="catId"
        v-for="[catId, group] in getComponents"
        v-bind:key="catId"
        :id="'gcmp_' + catId"
      >
        <image
          crossorigin="anonymous"
          v-for="image in group"
          v-bind:key="image.id"
          :id="'cmp_' + image.component_id"
          :width="image.width"
          :height="image.height"
          :data-name="image['data-name']"
          :data-href="
            '/configurator/configurations/' +
            bikeConfiguration[0]?.directory +
            '/' +
            image['data-href']
          "
          :src="
            '/configurator/configurations/' +
            bikeConfiguration[0]?.directory +
            '/' +
            image['data-href']
          "
          :transform="image.transform"
          :color-type="image['color_type']"
          :color="image['color']"
          :data-frame-finish="getFrameFinishKey(image)"
        ></image>
      </g>
    </svg>
  </section>
</template>

<script>
import { componentCategoryOrder } from "../../utils/colourRules";

export default {
  name: "configurator-imager",
  data() {
    return {};
  },
  props: ["bike", "results", "componentsConfig", "bikeConfiguration", "where"],
  methods: {
    getFrameFinishKey: function (image) {
      const attrId = image.attr_id || image["attr-id"];
      if (typeof attrId != "string" || !attrId.startsWith("frame_finish:")) {
        return null;
      }

      return attrId.replace("frame_finish:", "");
    },
    refreshFrameFinishLayer: function () {
      const finish = this.results?.frame?.finish;
      const layers = document.querySelectorAll("[data-frame-finish]");

      if (!layers.length || finish == null) {
        return;
      }

      layers.forEach((layer) => {
        layer.removeAttribute("href");
      });

      const finishKey = this.getSelectedFrameFinishKey(finish);
      let selectedLayer = finishKey
        ? document.querySelector('[data-frame-finish="' + finishKey + '"]')
        : null;

      if (selectedLayer == null && finish.id != null) {
        selectedLayer = document.querySelector("#cmp_" + finish.id + "[data-frame-finish]");
      }

      if (selectedLayer != null) {
        selectedLayer.setAttribute("href", selectedLayer.dataset.href);
      }
    },
    getSelectedFrameFinishKey: function (finish) {
      if (finish.frame_finish_key != null) {
        return finish.frame_finish_key;
      }

      if (finish.attr_id != null && finish.attr_id.startsWith("frame_finish:")) {
        return finish.attr_id.replace("frame_finish:", "");
      }

      if (finish.name == null) {
        return null;
      }

      return finish.name
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
    refreshComponent: function () {
      this.refreshFrameFinishLayer();

      if (this.results != null) {
        for (const [key, value] of Object.entries(this.results)) {
          if (key != "frame" && key != "colour" && value != null && value.id != null) {
            var elementId = "cmp_" + value.id;
            var element;

            if (value.colour != null) {
              element = document.querySelectorAll(
                "#" + elementId + '[color="' + value.colour + '"]'
              );
              if (element == null) {
                element = document.querySelectorAll("#" + elementId);
              }
            } else {
              element = document.querySelectorAll("#" + elementId);
            }

            if (element != null) {
              Array.prototype.forEach.call(element, function (node) {
                let hrefValue = node.dataset.href;
                node.setAttribute("href", hrefValue);
              });
            }
          }

          if (key == "colour") {
            var primaryCol = document.querySelectorAll(
              '#gcmp_25 image[color="' + value.primaryColor + '"][color-type="0"]'
            );
            Array.prototype.forEach.call(primaryCol, function (node) {
              node.setAttribute("href", node.dataset.href);
            });

            // primaryCol.setAttribute("href", primaryCol.dataset.href);

            if (
              this.bikeConfiguration[0] !== undefined &&
              this.bikeConfiguration[0].bike_id != 23 &&
              this.bikeConfiguration[0].bike_id != 20 &&
              this.bikeConfiguration[0].bike_id != 16
            ) {
              var secondaryCol = document.querySelectorAll(
                '#gcmp_25 image[color="' + value.secondaryColor + '"][color-type="1"]'
              );
              Array.prototype.forEach.call(secondaryCol, function (node) {
                node.setAttribute("href", node.dataset.href);
              });
            }
          }
        }
      }
    },
  },
  computed: {
    getFrame: function () {
      for (let [catId, subGroup] of Object.entries(this.componentsConfig)) {
        let group = this.componentsConfig[catId];
        if (group != null) {
          for (let i = 0; i < group.length; i++) {
            let configurationLine = group[i];
            if (configurationLine.component_type_id == 25) {
                console.log(configurationLine)
              return configurationLine;
            }
          }
        }
      }
      return null;
    },
    getComponents: function () {
      let ret = {};
      ret = Object.entries(this.componentsConfig);

      let indexToRemove = 0;
      let exit = false;

      for (const [catId, group] of Object.entries(this.componentsConfig)) {
        indexToRemove++;
        for (const [configurationLine, index] in group) {
          /* if (configurationLine.component_type_id == 25 || catId == 25) {
            exit = true;
            break;
          } */
        }
        if (exit) {
          break;
        }
      }

      // delete ret[indexToRemove - 1];
      //const newRet = ret.filter((a) => a);
      //return newRet;
      //return newRet.reverse();
      /**/
      let finalC = ret.filter((a) => a);

      const bikeId = this.bikeConfiguration[0]
        ? this.bikeConfiguration[0].bike_id
        : null;
      const catOrders = componentCategoryOrder(bikeId);
      // let catOrders = ["25", "4", "5", "6", "8", "9","10","11","14","7","23"];

      let catById = {};
      for (let i in finalC) {
        let keyid = "" + finalC[i][0];
        catById[keyid] = finalC[i];
      }
      let finalCOrderd = [];

      for (let o in catOrders) {
        let keyidO = catOrders[o];
        let val = catById[keyidO];

        if (val !== undefined) {
          finalCOrderd.push(val);
        }
      }

      return finalCOrderd;
    },
  },
  mounted() {
    let t = this;
    setTimeout(function () {
      t.refreshComponent();
    }, 400);

    setTimeout(function () {
      const svgElement = document.getElementById("svg-image");
      const viewBox = svgElement.getAttribute("viewBox").split(" ");
      const svgWidth = viewBox[2];
      const svgHeight = viewBox[3];

      // imposta la larghezza e l'altezza basate sul viewBox
      // svgElement.style.setProperty("width", 200);
      // svgElement.style.setProperty("height", svgHeight);
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
#cmp_imager {
  #swg-image {
    /*max-width: 940px;*/
  }
  /*
  @media (min-width: 1000px) and (min-height: 840px){
    height: 100%;
    position: relative;
    overflow: hidden;
    svg {
      position: absolute;
      transform: translateY(-10%);
    }
  }
  */
}

// Fix position for 'VINCI' bike
#svg-image[data-bike-id="27"] {
    transform: translateY(8%) scale(0.8);
}
@media screen and (min-width: 1440px) {
    #svg-image[data-bike-id="27"] {
        transform: translateY(18%) scale(1);
    }
}
@media screen and (min-width: 1440px) and (max-width: 1600px) {
    #svg-image[data-bike-id="27"] {
        transform: translateY(10%) scale(0.85);
    }
}

#svg-image[data-bike-id="33"] {
    transform: translateY(5vw) scale(0.9);
}

// Fix scale for 'OT-01' - 'XXTI 2026' bikes - 'Cicloprato 2026' bikes
#svg-image[data-bike-id="29"] g,
#svg-image[data-bike-id="30"] g,
#svg-image[data-bike-id="32"] g,
#svg-image[data-bike-id="33"] g {
    transform: scale(0.225) !important;
}
</style>
